import { purgeAllObsoleteItems } from '../services/dbMaintenance'
import { useAppStore } from '../stores/app'
import { useContextsStore } from '../stores/contexts'
/* import { useLabelsStore } from '../stores/labels' */

export default defineNuxtPlugin({
  name: 'init',
  async setup() {
    const appStore = useAppStore()
    const contextsStore = useContextsStore()
    /* const labelsStore = useLabelsStore() */

    /**
     * Sets up the PWA prompt event listener.
     * Adds an event listener for the 'beforeinstallprompt' event and prevents the default behavior.
     * Calls the 'setPwaPrompt' method of the 'appStore' object that allows the user to install the PWA.
     *
     * @listens window:beforeinstallprompt
     * @returns {void}
     */
    if (import.meta.client) {
      window.addEventListener('beforeinstallprompt', (event: Event) => {
        event.preventDefault()
        appStore.setPwaPrompt()
      })
    }

    /**
     * Check if onboarding has already been completed and initialize the app
     */
    await appStore.initializeApp()

    /* Clean up the database */
    await purgeAllObsoleteItems()

    /* Initialize contexts */
    await contextsStore.initializeContexts()

    /*
    if (!contextsStore.isInitialized) {
      console.log('Initializing')
      await appStore.startOnboarding()
    } */

    /* Initialize labels */
    /*     if (!labelsStore.isLoaded) {
      await labelsStore.loadLabels()
    } */
  }
})
